"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Scale = void 0;
exports.Scale = {
    apply: (v, scale = 1, offset = 0) => (v - offset) / scale,
    unapply: (v, scale = 1, offset = 0) => v * scale + offset,
};
